import type { SlideDef } from "@/engine/types";
import { TechnicalSeoSlide } from "./01-technical";
import { TechnicalPracticeSlide } from "./02-technical-practice";
import { LocalSeoSlide } from "./03-local";
import { MobileSeoSlide } from "./04-mobile";

export const slides: SlideDef[] = [
  {
    id: "c4-technical",
    chapter: 4,
    title: "Technical SEO",
    component: TechnicalSeoSlide,
  },
  {
    id: "c4-technical-practice",
    chapter: 4,
    title: "Technical SEO in practice",
    component: TechnicalPracticeSlide,
  },
  {
    id: "c4-local",
    chapter: 4,
    title: "Local SEO",
    component: LocalSeoSlide,
  },
  {
    id: "c4-mobile",
    chapter: 4,
    title: "Mobile SEO",
    component: MobileSeoSlide,
  },
];
